import { Backdrop } from './components/Backdrop/Backdrop.js';
import { CampusStrip } from './components/CampusStrip/CampusStrip.js';
import { Explainer } from './components/Explainer/Explainer.js';
import { Footer } from './components/Footer/Footer.js';
import { Header } from './components/Header/Header.js';
import { Hero } from './components/Hero/Hero.js';
import { InstallPanel } from './components/InstallPanel/InstallPanel.js';
import { OurDream } from './components/OurDream/OurDream.js';
import { ServiceLauncher } from './components/ServiceLauncher/ServiceLauncher.js';
import { SupportCard } from './components/SupportCareers/SupportCard.js';
import { TeamSection } from './components/TeamSection/TeamSection.js';
import { TrustStats } from './components/TrustStats/TrustStats.js';
import { WhyCarii } from './components/WhyCarii/WhyCarii.js';

/** Composition only — no logic. Every section owns its own content/behavior. */
export function App() {
  return (
    <div
      style={{
        position: 'relative',
        minHeight: '100%',
        background: 'var(--canvas)',
        color: 'var(--ink)',
      }}
    >
      <Backdrop />
      <div style={{ position: 'relative', zIndex: 1 }}>
        <Header />
        <Hero />
        <CampusStrip />
        <ServiceLauncher />
        <Explainer />
        <TrustStats />
        <WhyCarii />
        <OurDream />
        <TeamSection />
        <InstallPanel />
        <SupportCard />
        <Footer />
      </div>
    </div>
  );
}
